import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueSwal from 'vue-swal'
import helpers from './helpers'
import FBSignInButton from 'vue-facebook-signin-button'
import Sticky from 'vue-sticky-directive'
import 'animate.css/animate.css'
import store from './store'
import money from 'v-money'
import OneSignalVue from 'onesignal-vue'
import VueConfetti from 'vue-confetti'
import pkg from '../package.json'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../assets/css/main.css'
import 'leaflet/dist/leaflet.css';

Vue.use(VueSwal);
Vue.use(helpers);
Vue.use(VueResource);
Vue.use(FBSignInButton);
Vue.use(Sticky);
Vue.use(OneSignalVue);
Vue.use(VueConfetti);

Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
});

Vue.config.productionTip = false;

Vue.filter('valor', function (value) {
  if (value === undefined || value === null) {
    return value;
  }
  let formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter('getDay', function (value) {
  if (value === undefined || value === null) {
    return value;
  }

  switch (value) {
    case "1":
      return "Domingo";
    case "2":
      return "Segunda-Feira";
    case "3":
      return "Terça-Feira";
    case "4":
      return "Quarta-Feira";
    case "5":
      return "Quinta-Feira";
    case "6":
      return "Sexta-Feira";
    case "7":
      return "Sábado";
    default:
      return value
  }
});

Vue.filter('percent', function (value) {
  if (value !== null || value !== undefined) {
    return parseFloat(value).toFixed();
  }
});

Vue.filter('kilometer', function (value) {
  if (value !== null || value !== undefined) {
    const formated = parseFloat(value / 1000).toFixed(1);
    return formated + 'km';
  }
});

Vue.filter('maskPhone', function (phone) {
  if (phone) {
    if (phone.length === 10) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

    } else if (phone.length === 11) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
  }

  return phone
});

Vue.filter('tempo', function (value) {
  if (!isNaN(value)) {
    value = parseInt(value || '0');

    if (!value) {
      return `Hoje`;

    } else {
      return value >= 1440 ? `${(value / 1440).toFixed()} dia${value > 2159 ? 's' : ''}` : `${value} mins`;
    }
  }
});

const base_server = getAmbiente() + '/delivery/';
const base_cdn = 'https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com';
const base_assets = `${base_cdn}/lecard-go`;
const modo_catalogo = process.env.VUE_APP_MODO_CATALOGO === 'true';

function getAmbiente() {
  const server = process.env.VUE_APP_AMBIENTE || null;

  switch (server) {
    case '4':
      return 'http://localhost/lecard-server';

    case '3':
      return 'https://dev.lecard.app.br';

    case '2':
      return 'https://beta.lecard.app.br';

    default:
      return 'https://api.lecard.app.br/';
  }
}

Vue.mixin({
  data() {
    return {
      server: base_server,
      base_cdn: `${base_cdn}/lecard-corporativo`,
      app_version: pkg.version,
      base_assets,
      envEmpresa: {},

      origin: '5',
      franquiasEnabled: false,
      oneSignalIntegration: false,
      isAndroid: /(android)/i.test(navigator.userAgent),
      isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
      android_installed: false,
      ios_installed: (window.navigator.standalone === true),
      isInstagram: !navigator.userAgent.includes("Instagram"),

      img_default: (base_cdn + '/lecard-corporativo/static/imgs/default.png'),
      modo_catalogo,
      ocultar_cidade: false
    }
  },

  methods: {
    setSentry(data) {}
  }
});

Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;
Vue.http.options.root = base_server;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
